import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const store = useStore();
        onMounted(async () => {
            if (localStorage.getItem('token')) {
                // store.commit('setHistroyList')
                // store.commit('setDrawHistroyList')
                // store.commit('setSimpleList')
                // store.dispatch('getUserInfo')
                // store.dispatch('intelligence/getHistoryList')
                // store.dispatch('intelligence/getAllList')
                // store.dispatch('getVesion')
                store.commit('setToken', localStorage.getItem('token') || '');
            }
            else {
                store.dispatch('getModelList');
            }
            // 初始化窗口变化
            handleResize();
            window.addEventListener('online', updateLineStatus);
            window.addEventListener('offline', updateLineStatus);
            window.addEventListener('resize', handleResize);
        });
        onUnmounted(() => {
            window.removeEventListener('online', updateLineStatus);
            window.removeEventListener('offline', updateLineStatus);
            window.removeEventListener('resize', handleResize);
        });
        // 网络状态
        const updateLineStatus = () => {
            store.commit('setLineStatus');
        };
        // 窗口变化
        const handleResize = () => {
            store.commit('setIsMobile', window.innerWidth < 1024);
        };
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_component_router_view));
        };
    }
});
